// PostHog removed. Stub helpers preserved to avoid import errors while migrating.
// Production-safe no-op functions that return consistent values

export function initPosthog(): void {
  // no-op
}

export function track(_event: string, _properties?: Record<string, any>): void {
  // no-op - safely handles analytics calls in production
}

export function pageview(_props?: Record<string, any>): void {
  // no-op
}

export function identify(_distinctId: string, _props?: Record<string, any>): void {
  // no-op
}

export function group(_type: string, _id: string, _props?: Record<string, any>): void {
  // no-op
}

export function reset(): void {
  // no-op
}
